var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},[_c('img',{staticClass:"visionboard-preview",attrs:{"src":_vm.visionboardPreview.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }